import React, { useState, useEffect } from 'react';
import Sidebar from '../components/Sidebar';
import axios from 'axios';

const API = 'https://app.b3rastreamento.com.br/api';

const ciclos = [
  { value: 'MONTHLY', label: 'Mensal' },
  { value: 'WEEKLY', label: 'Semanal' },
  { value: 'BIWEEKLY', label: 'Quinzenal' },
  { value: 'QUARTERLY', label: 'Trimestral' },
  { value: 'SEMIANNUALLY', label: 'Semestral' },
  { value: 'YEARLY', label: 'Anual' },
];

const formasPagamento = [
  { value: 'BOLETO', label: '🏦 Boleto' },
  { value: 'PIX', label: '⚡ PIX' },
  { value: 'CREDIT_CARD', label: '💳 Cartão de Crédito' },
];

const gateways = [
  { value: 'asaas', label: 'Asaas' },
  { value: 'cora', label: 'Cora' },
  { value: 'c6bank', label: 'C6 Bank' },
  { value: 'pagseguro', label: 'PagSeguro' },
  { value: 'mercadopago', label: 'Mercado Pago' },
];

function exportarCobrancasPDF(lista, tituloFiltro) {
  const conteudo = `
    <html>
    <head>
      <meta charset="utf-8">
      <title>Cobranças</title>
      <style>
        body { font-family: Arial, sans-serif; font-size: 12px; color: #333; padding: 20px; }
        h1 { color: #1D9E75; font-size: 18px; margin-bottom: 4px; }
        p { color: #999; font-size: 11px; margin-bottom: 20px; }
        table { width: 100%; border-collapse: collapse; }
        th { background: #1D9E75; color: white; padding: 8px 10px; text-align: left; font-size: 11px; }
        td { padding: 8px 10px; border-bottom: 1px solid #eee; font-size: 11px; }
        tr:nth-child(even) td { background: #f9f9f9; }
        .footer { margin-top: 20px; text-align: center; color: #999; font-size: 10px; }
      </style>
    </head>
    <body>
      <h1>Cobranças ${tituloFiltro ? `— ${tituloFiltro}` : ''}</h1>
      <p>Gerado em ${new Date().toLocaleString('pt-BR')} — ${lista.length} cobrança${lista.length !== 1 ? 's' : ''} — Desenvolvido por Digital Mais BR</p>
      <table>
        <thead>
          <tr>
            <th>Cliente</th><th>Descrição</th><th>Valor</th><th>Vencimento</th><th>Forma</th><th>Status</th>
          </tr>
        </thead>
        <tbody>
          ${lista.map(c => `
            <tr>
              <td>${c.cliente_nome || '—'}</td>
              <td>${c.descricao || '—'}</td>
              <td>R$ ${parseFloat(c.valor || 0).toFixed(2)}</td>
              <td>${c.vencimento ? new Date(c.vencimento).toLocaleDateString('pt-BR') : '—'}</td>
              <td>${c.forma_pagamento || '—'}</td>
              <td>${c.status || '—'}</td>
            </tr>
          `).join('')}
        </tbody>
      </table>
      <div class="footer">Desenvolvido por Digital Mais BR — digitalmaisbr.com.br</div>
    </body>
    </html>
  `;
  const janela = window.open('', '_blank');
  janela.document.write(conteudo);
  janela.document.close();
  janela.focus();
  setTimeout(() => janela.print(), 500);
}

function exportarCobrancasCSV(lista) {
  const linhas = [
    'Cliente,Descrição,Valor,Vencimento,Forma,Status',
    ...lista.map(c => {
      const campos = [c.cliente_nome, c.descricao, parseFloat(c.valor || 0).toFixed(2), c.vencimento ? new Date(c.vencimento).toLocaleDateString('pt-BR') : '', c.forma_pagamento, c.status];
      return campos.map(v => `"${(v || '').toString().replace(/"/g, '""')}"`).join(',');
    })
  ];
  const blob = new Blob([String.fromCharCode(0xFEFF) + linhas.join(String.fromCharCode(10))], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = `cobrancas_${new Date().toISOString().slice(0,10)}.csv`;
  a.click();
}

function Financeiro() {
  const [sidebarAberta, setSidebarAberta] = useState(false);
  const [aba, setAba] = useState('dashboard');
  const [dashboard, setDashboard] = useState({});
  const [assinaturas, setAssinaturas] = useState([]);
  const [cobrancas, setCobrancas] = useState([]);
  const [clientes, setClientes] = useState([]);
  const [config, setConfig] = useState({});
  const [modalAssinatura, setModalAssinatura] = useState(false);
  const [modalCobranca, setModalCobranca] = useState(false);
  const [salvando, setSalvando] = useState(false);
  const [buscaCliente, setBuscaCliente] = useState('');
  const [mostrarSugestoes, setMostrarSugestoes] = useState(false);
  const [filtroStatus, setFiltroStatus] = useState('');

  const [formAssinatura, setFormAssinatura] = useState({
    cliente_id: '', descricao: '', valor: '', ciclo: 'MONTHLY',
    primeiro_vencimento: '', fim_definido: false, data_fim: '',
    multa_percentual: '2', juros_percentual: '1',
    desconto_percentual: '', desconto_ate_vencimento: false,
    nota_fiscal: false, nota_fiscal_automatica: false,
    envio_whatsapp: true, envio_email: true, envio_sms: false
  });

  const [formCobranca, setFormCobranca] = useState({
    cliente_id: '', descricao: '', valor: '', tipo: 'unica',
    forma_pagamento: 'BOLETO', parcelas: '1', vencimento: ''
  });

  const token = localStorage.getItem('token');
  const headers = { Authorization: `Bearer ${token}` };

  useEffect(() => { carregarDados(); }, []);

  const carregarDados = async () => {
    try {
      const [dashRes, assRes, cobRes, cliRes, confRes] = await Promise.all([
        axios.get(`${API}/financeiro/dashboard`, { headers }),
        axios.get(`${API}/financeiro/assinaturas`, { headers }),
        axios.get(`${API}/financeiro/cobrancas`, { headers }),
        axios.get(`${API}/clientes`, { headers }),
        axios.get(`${API}/financeiro/config`, { headers }),
      ]);
      setDashboard(dashRes.data);
      setAssinaturas(assRes.data);
      setCobrancas(cobRes.data);
      setClientes(cliRes.data);
      setConfig(confRes.data);
    } catch (err) { console.error(err); }
  };

  const clientesFiltrados = clientes.filter(c =>
    c && (c.nome_fantasia || c.nome) &&
    (c.nome_fantasia || c.nome).toLowerCase().includes(buscaCliente.toLowerCase())
  );

  const selecionarCliente = (cliente, setForm) => {
    setForm(prev => ({ ...prev, cliente_id: cliente.id }));
    setBuscaCliente(cliente.nome_fantasia || cliente.nome);
    setMostrarSugestoes(false);
  };

  const salvarAssinatura = async () => {
    if (!formAssinatura.cliente_id || !formAssinatura.valor || !formAssinatura.primeiro_vencimento) {
      alert('Cliente, valor e primeiro vencimento são obrigatórios!'); return;
    }
    setSalvando(true);
    try {
      await axios.post(`${API}/financeiro/assinaturas`, formAssinatura, { headers });
      setModalAssinatura(false);
      carregarDados();
    } catch (err) { alert(err.response?.data?.erro || 'Erro ao salvar'); }
    setSalvando(false);
  };

  const salvarCobranca = async () => {
    if (!formCobranca.cliente_id || !formCobranca.valor || !formCobranca.vencimento) {
      alert('Cliente, valor e vencimento são obrigatórios!'); return;
    }
    setSalvando(true);
    try {
      await axios.post(`${API}/financeiro/cobrancas`, formCobranca, { headers });
      setModalCobranca(false);
      carregarDados();
    } catch (err) { alert(err.response?.data?.erro || 'Erro ao salvar'); }
    setSalvando(false);
  };

  const baixarCobranca = async (id) => {
    if (!window.confirm('Confirmar baixa manual desta cobrança?')) return;
    await axios.patch(`${API}/financeiro/cobrancas/${id}/baixar`, {}, { headers });
    carregarDados();
  };

  const cancelarAssinatura = async (id) => {
    if (!window.confirm('Deseja cancelar esta assinatura?')) return;
    await axios.patch(`${API}/financeiro/assinaturas/${id}/cancelar`, {}, { headers });
    carregarDados();
  };

  const salvarConfig = async () => {
    setSalvando(true);
    try {
      await axios.post(`${API}/financeiro/config`, { ...config, modo: 'api_externa' }, { headers });
      alert('Configuração salva com sucesso!');
    } catch (err) { alert('Erro ao salvar configuração'); }
    setSalvando(false);
  };

  const cobrancasFiltradas = cobrancas.filter(c => !filtroStatus || c.status === filtroStatus);

  const statusCor = (status) => {
    if (status === 'pago') return { bg: '#E1F5EE', cor: '#0F6E56' };
    if (status === 'atrasado') return { bg: '#FCEBEB', cor: '#A32D2D' };
    if (status === 'cancelado') return { bg: '#f0f0f0', cor: '#666' };
    return { bg: '#FAEEDA', cor: '#633806' };
  };

  const inputStyle = { width: '100%', padding: '10px', borderRadius: '8px', border: '1px solid #ddd', fontSize: '14px', boxSizing: 'border-box' };
  const labelStyle = { fontSize: '12px', color: '#666', fontWeight: '600', display: 'block', marginBottom: '4px' };

  // Instrução de configuração por gateway
  const instrucaoGateway = (gw) => {
    if (gw === 'c6bank') return {
      passos: [
        'Acesse o C6 Bank Empresas e vá em Integrações → API',
        'Gere uma nova chave de API na seção de cobranças',
        'Cole a API Key no campo ao lado e salve',
        'Pronto! PIX e boletos serão gerados diretamente na sua conta C6',
      ],
      aviso: 'O C6 Bank suporta cobranças via PIX e boleto bancário para contas PJ.'
    };
    return {
      passos: [
        'Crie uma conta gratuita no Asaas, Cora ou outro gateway de sua preferência',
        'Acesse Configurações → Integrações → Gerar nova Chave de API',
        'Cole a API Key no campo ao lado e salve',
        'Pronto! Boletos, PIX e cartão serão gerados automaticamente na sua conta',
      ],
      aviso: 'Cada cliente usa a própria conta e recebe os pagamentos diretamente. Seus dados financeiros ficam 100% separados.'
    };
  };

  const instrucao = instrucaoGateway(config.gateway);

  return (
    <div style={{ minHeight: '100vh', background: '#f5f5f5' }}>
      <Sidebar aberta={sidebarAberta} setAberta={setSidebarAberta} />

      <div style={{ background: '#1D9E75', padding: '0 24px', height: '60px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', position: 'fixed', top: 0, left: 0, right: 0, zIndex: 500, boxShadow: '0 2px 10px rgba(0,0,0,0.2)' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
          <button onClick={() => setSidebarAberta(!sidebarAberta)} style={{ background: 'none', border: 'none', cursor: 'pointer', fontSize: '22px', color: 'white' }}>{sidebarAberta ? '✕' : '☰'}</button>
          <span style={{ color: 'white', fontWeight: '700', fontSize: '18px' }}>💰 Financeiro</span>
        </div>
        <div style={{ display: 'flex', gap: '8px' }}>
          {aba === 'assinaturas' && (
            <button onClick={() => { setBuscaCliente(''); setFormAssinatura({ cliente_id: '', descricao: '', valor: '', ciclo: 'MONTHLY', primeiro_vencimento: '', fim_definido: false, data_fim: '', multa_percentual: '2', juros_percentual: '1', desconto_percentual: '', desconto_ate_vencimento: false, nota_fiscal: false, nota_fiscal_automatica: false, envio_whatsapp: true, envio_email: true, envio_sms: false }); setModalAssinatura(true); }}
              style={{ background: 'rgba(255,255,255,0.2)', color: 'white', border: '1px solid rgba(255,255,255,0.4)', borderRadius: '8px', padding: '8px 16px', cursor: 'pointer', fontWeight: '600', fontSize: '14px' }}>
              + Nova Assinatura
            </button>
          )}
          {aba === 'cobrancas' && (
            <button onClick={() => { setBuscaCliente(''); setFormCobranca({ cliente_id: '', descricao: '', valor: '', tipo: 'unica', forma_pagamento: 'BOLETO', parcelas: '1', vencimento: '' }); setModalCobranca(true); }}
              style={{ background: 'rgba(255,255,255,0.2)', color: 'white', border: '1px solid rgba(255,255,255,0.4)', borderRadius: '8px', padding: '8px 16px', cursor: 'pointer', fontWeight: '600', fontSize: '14px' }}>
              + Nova Cobrança
            </button>
          )}
        </div>
      </div>

      <div style={{ marginTop: '60px', padding: '24px' }}>

        <div style={{ display: 'flex', gap: '8px', marginBottom: '20px', background: 'white', borderRadius: '12px', padding: '8px', boxShadow: '0 1px 4px rgba(0,0,0,0.08)' }}>
          {[
            { key: 'dashboard', label: '📊 Dashboard' },
            { key: 'assinaturas', label: '🔄 Assinaturas' },
            { key: 'cobrancas', label: '📄 Cobranças' },
            { key: 'config', label: '⚙️ Configurações' },
          ].map(a => (
            <button key={a.key} onClick={() => setAba(a.key)} style={{
              background: aba === a.key ? '#1D9E75' : 'transparent',
              color: aba === a.key ? 'white' : '#666',
              border: 'none', borderRadius: '8px', padding: '8px 16px',
              cursor: 'pointer', fontWeight: '600', fontSize: '13px', transition: 'all .2s'
            }}>{a.label}</button>
          ))}
        </div>

        {/* DASHBOARD */}
        {aba === 'dashboard' && (
          <div>
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: '16px', marginBottom: '24px' }}>
              {[
                { label: 'A Receber (mês)', valor: `R$ ${(dashboard.a_receber || 0).toFixed(2)}`, cor: '#378ADD', icon: '📥' },
                { label: 'Recebido (mês)', valor: `R$ ${(dashboard.recebido || 0).toFixed(2)}`, cor: '#1D9E75', icon: '✅' },
                { label: 'Em Atraso', valor: `R$ ${(dashboard.atrasado || 0).toFixed(2)}`, cor: '#E24B4A', icon: '⚠️' },
                { label: 'Assinaturas Ativas', valor: dashboard.assinaturas_ativas || 0, cor: '#F59E0B', icon: '🔄' },
              ].map((c, i) => (
                <div key={i} style={{ background: 'white', borderRadius: '12px', padding: '20px', boxShadow: '0 1px 4px rgba(0,0,0,0.08)', borderLeft: `4px solid ${c.cor}` }}>
                  <div style={{ fontSize: '24px', marginBottom: '8px' }}>{c.icon}</div>
                  <div style={{ fontSize: '22px', fontWeight: '700', color: c.cor }}>{c.valor}</div>
                  <div style={{ fontSize: '13px', color: '#666', marginTop: '4px' }}>{c.label}</div>
                </div>
              ))}
            </div>
            <div style={{ background: 'white', borderRadius: '12px', padding: '20px', boxShadow: '0 1px 4px rgba(0,0,0,0.08)' }}>
              <h3 style={{ margin: '0 0 16px', fontSize: '15px', color: '#333' }}>📄 Últimas Cobranças</h3>
              <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                <thead>
                  <tr>{['Cliente', 'Descrição', 'Valor', 'Vencimento', 'Status'].map(h => <th key={h} style={{ padding: '10px', textAlign: 'left', fontSize: '12px', color: '#666', borderBottom: '1px solid #eee' }}>{h}</th>)}</tr>
                </thead>
                <tbody>
                  {cobrancas.slice(0, 10).map((c, i) => {
                    const st = statusCor(c.status);
                    return (
                      <tr key={i} style={{ borderBottom: '1px solid #f5f5f5' }}>
                        <td style={{ padding: '10px', fontSize: '13px' }}>{c.cliente_nome}</td>
                        <td style={{ padding: '10px', fontSize: '13px', color: '#666' }}>{c.descricao}</td>
                        <td style={{ padding: '10px', fontSize: '13px', fontWeight: '600', color: '#1D9E75' }}>R$ {parseFloat(c.valor).toFixed(2)}</td>
                        <td style={{ padding: '10px', fontSize: '12px', color: '#666' }}>{new Date(c.vencimento).toLocaleDateString('pt-BR')}</td>
                        <td style={{ padding: '10px' }}><span style={{ background: st.bg, color: st.cor, padding: '3px 8px', borderRadius: '12px', fontSize: '11px', fontWeight: '500' }}>{c.status}</span></td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          </div>
        )}

        {/* ASSINATURAS */}
        {aba === 'assinaturas' && (
          <div style={{ background: 'white', borderRadius: '12px', boxShadow: '0 1px 4px rgba(0,0,0,0.08)', overflow: 'hidden' }}>
            <table style={{ width: '100%', borderCollapse: 'collapse' }}>
              <thead style={{ background: '#f8f8f8' }}>
                <tr>{['Cliente', 'Descrição', 'Valor', 'Ciclo', 'Próx. Vencimento', 'Status', 'Ações'].map(h => <th key={h} style={{ padding: '12px 16px', textAlign: 'left', fontSize: '12px', color: '#666', fontWeight: '600', borderBottom: '1px solid #eee' }}>{h}</th>)}</tr>
              </thead>
              <tbody>
                {assinaturas.length === 0 ? (
                  <tr><td colSpan="7" style={{ padding: '32px', textAlign: 'center', color: '#999' }}>Nenhuma assinatura cadastrada.</td></tr>
                ) : assinaturas.map((a, i) => (
                  <tr key={i} style={{ borderBottom: '1px solid #f0f0f0' }}>
                    <td style={{ padding: '12px 16px', fontSize: '13px', fontWeight: '500' }}>{a.cliente_nome}</td>
                    <td style={{ padding: '12px 16px', fontSize: '13px', color: '#666' }}>{a.descricao}</td>
                    <td style={{ padding: '12px 16px', fontSize: '13px', fontWeight: '600', color: '#1D9E75' }}>R$ {parseFloat(a.valor).toFixed(2)}</td>
                    <td style={{ padding: '12px 16px', fontSize: '12px' }}>{ciclos.find(c => c.value === a.ciclo)?.label || a.ciclo}</td>
                    <td style={{ padding: '12px 16px', fontSize: '12px', color: '#666' }}>{new Date(a.primeiro_vencimento).toLocaleDateString('pt-BR')}</td>
                    <td style={{ padding: '12px 16px' }}>
                      <span style={{ background: a.status === 'ativa' ? '#E1F5EE' : '#FCEBEB', color: a.status === 'ativa' ? '#0F6E56' : '#A32D2D', padding: '3px 8px', borderRadius: '12px', fontSize: '11px', fontWeight: '500' }}>{a.status}</span>
                    </td>
                    <td style={{ padding: '12px 16px' }}>
                      {a.status === 'ativa' && (
                        <button onClick={() => cancelarAssinatura(a.id)} style={{ background: '#FCEBEB', color: '#A32D2D', border: 'none', borderRadius: '6px', padding: '6px 12px', cursor: 'pointer', fontSize: '12px' }}>Cancelar</button>
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}

        {/* COBRANÇAS */}
        {aba === 'cobrancas' && (
          <div>
            <div style={{ display: 'flex', gap: '8px', marginBottom: '16px', justifyContent: 'space-between', flexWrap: 'wrap' }}>
              <div style={{ display: 'flex', gap: '8px' }}>
                {['', 'pendente', 'pago', 'atrasado'].map(s => (
                  <button key={s} onClick={() => setFiltroStatus(s)} style={{
                    background: filtroStatus === s ? '#1D9E75' : 'white',
                    color: filtroStatus === s ? 'white' : '#666',
                    border: '1px solid #ddd', borderRadius: '8px', padding: '6px 14px',
                    cursor: 'pointer', fontSize: '13px', fontWeight: '500'
                  }}>{s === '' ? 'Todas' : s.charAt(0).toUpperCase() + s.slice(1)}</button>
                ))}
              </div>
              <div style={{ display: 'flex', gap: '8px' }}>
                <button onClick={() => exportarCobrancasPDF(cobrancasFiltradas, filtroStatus !== '' ? filtroStatus.charAt(0).toUpperCase() + filtroStatus.slice(1) : null)} style={{ background: 'white', color: '#666', border: '1px solid #ddd', borderRadius: '8px', padding: '6px 14px', cursor: 'pointer', fontSize: '13px', fontWeight: '500' }}>📄 Exportar PDF</button>
                <button onClick={() => exportarCobrancasCSV(cobrancasFiltradas)} style={{ background: 'white', color: '#666', border: '1px solid #ddd', borderRadius: '8px', padding: '6px 14px', cursor: 'pointer', fontSize: '13px', fontWeight: '500' }}>📥 Exportar Excel</button>
              </div>
            </div>
            <div style={{ background: 'white', borderRadius: '12px', boxShadow: '0 1px 4px rgba(0,0,0,0.08)', overflow: 'hidden' }}>
              <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                <thead style={{ background: '#f8f8f8' }}>
                  <tr>{['Cliente', 'Descrição', 'Valor', 'Vencimento', 'Forma', 'Status', 'Ações'].map(h => <th key={h} style={{ padding: '12px 16px', textAlign: 'left', fontSize: '12px', color: '#666', fontWeight: '600', borderBottom: '1px solid #eee' }}>{h}</th>)}</tr>
                </thead>
                <tbody>
                  {cobrancasFiltradas.length === 0 ? (
                    <tr><td colSpan="7" style={{ padding: '32px', textAlign: 'center', color: '#999' }}>Nenhuma cobrança encontrada.</td></tr>
                  ) : cobrancasFiltradas.map((c, i) => {
                    const st = statusCor(c.status);
                    return (
                      <tr key={i} style={{ borderBottom: '1px solid #f0f0f0' }}>
                        <td style={{ padding: '12px 16px', fontSize: '13px', fontWeight: '500' }}>{c.cliente_nome}</td>
                        <td style={{ padding: '12px 16px', fontSize: '13px', color: '#666' }}>{c.descricao}</td>
                        <td style={{ padding: '12px 16px', fontSize: '13px', fontWeight: '600', color: '#1D9E75' }}>R$ {parseFloat(c.valor).toFixed(2)}</td>
                        <td style={{ padding: '12px 16px', fontSize: '12px', color: '#666' }}>{new Date(c.vencimento).toLocaleDateString('pt-BR')}</td>
                        <td style={{ padding: '12px 16px', fontSize: '12px' }}>{formasPagamento.find(f => f.value === c.forma_pagamento)?.label || c.forma_pagamento || '—'}</td>
                        <td style={{ padding: '12px 16px' }}><span style={{ background: st.bg, color: st.cor, padding: '3px 8px', borderRadius: '12px', fontSize: '11px', fontWeight: '500' }}>{c.status}</span></td>
                        <td style={{ padding: '12px 16px' }}>
                          {c.status === 'pendente' && (
                            <button onClick={() => baixarCobranca(c.id)} style={{ background: '#E1F5EE', color: '#0F6E56', border: 'none', borderRadius: '6px', padding: '6px 12px', cursor: 'pointer', fontSize: '12px' }}>✅ Baixar</button>
                          )}
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          </div>
        )}

        {/* CONFIGURAÇÕES */}
        {aba === 'config' && (
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '24px' }}>
            <div style={{ background: 'white', borderRadius: '12px', padding: '24px', boxShadow: '0 1px 4px rgba(0,0,0,0.08)' }}>
              <h3 style={{ margin: '0 0 20px', fontSize: '15px', color: '#333' }}>⚙️ Gateway de Pagamento</h3>

              <div style={{ marginBottom: '14px' }}>
                <label style={labelStyle}>Gateway</label>
                <select value={config.gateway || ''} onChange={e => setConfig(prev => ({ ...prev, gateway: e.target.value, modo: 'api_externa' }))} style={{ ...inputStyle, background: 'white' }}>
                  <option value="">Selecione o gateway...</option>
                  {gateways.map(g => <option key={g.value} value={g.value}>{g.label}</option>)}
                </select>
              </div>

              <div style={{ marginBottom: '14px' }}>
                <label style={labelStyle}>API Key</label>
                <input type="password" placeholder="Cole sua API Key aqui..." value={config.api_key || ''} onChange={e => setConfig(prev => ({ ...prev, api_key: e.target.value }))} style={inputStyle} />
                <div style={{ fontSize: '11px', color: '#999', marginTop: '4px' }}>🔒 Sua chave é armazenada de forma segura e nunca é exibida</div>
              </div>

              <h3 style={{ margin: '20px 0 16px', fontSize: '15px', color: '#333' }}>💰 Regras de Cobrança</h3>
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px' }}>
                {[
                  { label: 'Multa (%)', key: 'multa_percentual' },
                  { label: 'Juros ao mês (%)', key: 'juros_percentual' },
                  { label: 'Dias para corte de acesso', key: 'dias_corte' },
                ].map(f => (
                  <div key={f.key}>
                    <label style={labelStyle}>{f.label}</label>
                    <input type="number" value={config[f.key] || ''} onChange={e => setConfig(prev => ({ ...prev, [f.key]: e.target.value }))} style={inputStyle} />
                  </div>
                ))}
              </div>

              <button onClick={salvarConfig} disabled={salvando} style={{ width: '100%', background: salvando ? '#ccc' : '#1D9E75', color: 'white', border: 'none', borderRadius: '8px', padding: '12px', cursor: salvando ? 'not-allowed' : 'pointer', fontWeight: '600', marginTop: '20px', fontSize: '14px' }}>
                {salvando ? '⏳ Salvando...' : '✅ Salvar Configurações'}
              </button>
            </div>

            <div style={{ background: 'white', borderRadius: '12px', padding: '24px', boxShadow: '0 1px 4px rgba(0,0,0,0.08)' }}>
              <h3 style={{ margin: '0 0 16px', fontSize: '15px', color: '#333' }}>📋 Como configurar</h3>
              <div style={{ display: 'flex', flexDirection: 'column', gap: '14px' }}>
                {instrucao.passos.map((p, i) => (
                  <div key={i} style={{ display: 'flex', gap: '12px', alignItems: 'flex-start' }}>
                    <div style={{ width: '24px', height: '24px', borderRadius: '50%', background: '#1D9E75', color: 'white', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '12px', fontWeight: '700', flexShrink: 0 }}>{i + 1}</div>
                    <div style={{ fontSize: '13px', color: '#666', lineHeight: '1.5' }}>{p}</div>
                  </div>
                ))}
                <div style={{ background: '#f8f8f8', borderRadius: '8px', padding: '12px', fontSize: '12px', color: '#666', marginTop: '8px' }}>
                  ⚠️ <strong>Importante:</strong> {instrucao.aviso}
                </div>
              </div>
            </div>
          </div>
        )}
      </div>

      {/* MODAL ASSINATURA */}
      {modalAssinatura && (
        <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(0,0,0,0.5)', zIndex: 1000, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '20px' }}>
          <div style={{ background: 'white', borderRadius: '16px', width: '800px', maxWidth: '100%', maxHeight: '90vh', overflowY: 'auto', boxShadow: '0 20px 60px rgba(0,0,0,0.3)' }}>
            <div style={{ padding: '20px 24px', borderBottom: '1px solid #eee', display: 'flex', justifyContent: 'space-between', alignItems: 'center', position: 'sticky', top: 0, background: 'white', zIndex: 1 }}>
              <h2 style={{ margin: 0, fontSize: '18px' }}>🔄 Nova Assinatura</h2>
              <button onClick={() => setModalAssinatura(false)} style={{ background: 'none', border: 'none', fontSize: '24px', cursor: 'pointer', color: '#999' }}>×</button>
            </div>
            <div style={{ padding: '24px', display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '24px' }}>
              <div>
                <h3 style={{ margin: '0 0 16px', fontSize: '13px', color: '#666', textTransform: 'uppercase' }}>Dados da Assinatura</h3>
                <div style={{ marginBottom: '14px', position: 'relative' }}>
                  <label style={labelStyle}>Cliente *</label>
                  <input type="text" placeholder="Digite para buscar..." value={buscaCliente}
                    onChange={e => { setBuscaCliente(e.target.value); setMostrarSugestoes(true); setFormAssinatura(prev => ({ ...prev, cliente_id: '' })); }}
                    onFocus={() => setMostrarSugestoes(true)}
                    onBlur={() => setTimeout(() => setMostrarSugestoes(false), 200)}
                    style={inputStyle} />
                  {mostrarSugestoes && buscaCliente && clientesFiltrados.length > 0 && (
                    <div style={{ position: 'absolute', top: '100%', left: 0, right: 0, background: 'white', border: '1px solid #ddd', borderRadius: '8px', boxShadow: '0 4px 12px rgba(0,0,0,0.15)', zIndex: 100, maxHeight: '200px', overflowY: 'auto' }}>
                      {clientesFiltrados.map((c, i) => (
                        <div key={i} onMouseDown={() => selecionarCliente(c, setFormAssinatura)} style={{ padding: '10px 14px', cursor: 'pointer', fontSize: '14px' }} onMouseEnter={e => e.currentTarget.style.background = '#E1F5EE'} onMouseLeave={e => e.currentTarget.style.background = 'white'}>
                          👤 {c.nome_fantasia || c.nome}
                        </div>
                      ))}
                    </div>
                  )}
                  {formAssinatura.cliente_id && <div style={{ fontSize: '11px', color: '#1D9E75', marginTop: '4px' }}>✅ Cliente selecionado</div>}
                </div>
                <div style={{ marginBottom: '14px' }}>
                  <label style={labelStyle}>Descrição</label>
                  <input type="text" placeholder="Ex: Mensalidade rastreamento" value={formAssinatura.descricao} onChange={e => setFormAssinatura(prev => ({ ...prev, descricao: e.target.value }))} style={inputStyle} />
                </div>
                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px', marginBottom: '14px' }}>
                  <div>
                    <label style={labelStyle}>Valor (R$) *</label>
                    <input type="number" placeholder="0,00" value={formAssinatura.valor} onChange={e => setFormAssinatura(prev => ({ ...prev, valor: e.target.value }))} style={inputStyle} />
                  </div>
                  <div>
                    <label style={labelStyle}>Ciclo</label>
                    <select value={formAssinatura.ciclo} onChange={e => setFormAssinatura(prev => ({ ...prev, ciclo: e.target.value }))} style={{ ...inputStyle, background: 'white' }}>
                      {ciclos.map(c => <option key={c.value} value={c.value}>{c.label}</option>)}
                    </select>
                  </div>
                </div>
                <div style={{ marginBottom: '14px' }}>
                  <label style={labelStyle}>Primeiro Vencimento *</label>
                  <input type="date" value={formAssinatura.primeiro_vencimento} onChange={e => setFormAssinatura(prev => ({ ...prev, primeiro_vencimento: e.target.value }))} style={inputStyle} />
                </div>
                <div style={{ marginBottom: '14px' }}>
                  <label style={{ display: 'flex', alignItems: 'center', gap: '8px', cursor: 'pointer', fontSize: '13px', color: '#333' }}>
                    <input type="checkbox" checked={formAssinatura.fim_definido} onChange={e => setFormAssinatura(prev => ({ ...prev, fim_definido: e.target.checked }))} />
                    Assinatura tem data de fim
                  </label>
                  {formAssinatura.fim_definido && (
                    <input type="date" value={formAssinatura.data_fim} onChange={e => setFormAssinatura(prev => ({ ...prev, data_fim: e.target.value }))} style={{ ...inputStyle, marginTop: '8px' }} />
                  )}
                </div>
              </div>
              <div>
                <h3 style={{ margin: '0 0 16px', fontSize: '13px', color: '#666', textTransform: 'uppercase' }}>Regras e Notificações</h3>
                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px', marginBottom: '14px' }}>
                  <div>
                    <label style={labelStyle}>Multa (%)</label>
                    <input type="number" value={formAssinatura.multa_percentual} onChange={e => setFormAssinatura(prev => ({ ...prev, multa_percentual: e.target.value }))} style={inputStyle} />
                  </div>
                  <div>
                    <label style={labelStyle}>Juros ao mês (%)</label>
                    <input type="number" value={formAssinatura.juros_percentual} onChange={e => setFormAssinatura(prev => ({ ...prev, juros_percentual: e.target.value }))} style={inputStyle} />
                  </div>
                  <div>
                    <label style={labelStyle}>Desconto (%)</label>
                    <input type="number" value={formAssinatura.desconto_percentual} onChange={e => setFormAssinatura(prev => ({ ...prev, desconto_percentual: e.target.value }))} style={inputStyle} />
                  </div>
                </div>
                <div style={{ marginBottom: '14px', background: '#f8f8f8', borderRadius: '10px', padding: '14px' }}>
                  <div style={{ fontSize: '12px', color: '#666', fontWeight: '600', marginBottom: '10px' }}>NOTA FISCAL</div>
                  {[
                    { key: 'nota_fiscal', label: 'Emitir nota fiscal' },
                    { key: 'nota_fiscal_automatica', label: 'Emitir automaticamente ao pagar' },
                  ].map(f => (
                    <label key={f.key} style={{ display: 'flex', alignItems: 'center', gap: '8px', cursor: 'pointer', fontSize: '13px', color: '#333', marginBottom: '8px' }}>
                      <input type="checkbox" checked={formAssinatura[f.key]} onChange={e => setFormAssinatura(prev => ({ ...prev, [f.key]: e.target.checked }))} />
                      {f.label}
                    </label>
                  ))}
                </div>
                <div style={{ background: '#f8f8f8', borderRadius: '10px', padding: '14px' }}>
                  <div style={{ fontSize: '12px', color: '#666', fontWeight: '600', marginBottom: '10px' }}>ENVIAR COBRANÇA POR</div>
                  {[
                    { key: 'envio_whatsapp', label: '💬 WhatsApp' },
                    { key: 'envio_email', label: '📧 Email' },
                    { key: 'envio_sms', label: '📱 SMS' },
                  ].map(f => (
                    <label key={f.key} style={{ display: 'flex', alignItems: 'center', gap: '8px', cursor: 'pointer', fontSize: '13px', color: '#333', marginBottom: '8px' }}>
                      <input type="checkbox" checked={formAssinatura[f.key]} onChange={e => setFormAssinatura(prev => ({ ...prev, [f.key]: e.target.checked }))} />
                      {f.label}
                    </label>
                  ))}
                </div>
              </div>
            </div>
            <div style={{ padding: '16px 24px', borderTop: '1px solid #eee', display: 'flex', justifyContent: 'flex-end', gap: '12px', position: 'sticky', bottom: 0, background: 'white' }}>
              <button onClick={() => setModalAssinatura(false)} style={{ background: '#f0f0f0', color: '#666', border: 'none', borderRadius: '8px', padding: '10px 20px', cursor: 'pointer', fontWeight: '600' }}>Cancelar</button>
              <button onClick={salvarAssinatura} disabled={salvando} style={{ background: salvando ? '#ccc' : '#1D9E75', color: 'white', border: 'none', borderRadius: '8px', padding: '10px 24px', cursor: salvando ? 'not-allowed' : 'pointer', fontWeight: '600' }}>
                {salvando ? '⏳ Salvando...' : '✅ Criar Assinatura'}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* MODAL COBRANÇA */}
      {modalCobranca && (
        <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(0,0,0,0.5)', zIndex: 1000, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '20px' }}>
          <div style={{ background: 'white', borderRadius: '16px', width: '500px', maxWidth: '100%', maxHeight: '90vh', overflowY: 'auto', boxShadow: '0 20px 60px rgba(0,0,0,0.3)' }}>
            <div style={{ padding: '20px 24px', borderBottom: '1px solid #eee', display: 'flex', justifyContent: 'space-between', alignItems: 'center', position: 'sticky', top: 0, background: 'white', zIndex: 1 }}>
              <h2 style={{ margin: 0, fontSize: '18px' }}>📄 Nova Cobrança</h2>
              <button onClick={() => setModalCobranca(false)} style={{ background: 'none', border: 'none', fontSize: '24px', cursor: 'pointer', color: '#999' }}>×</button>
            </div>
            <div style={{ padding: '24px', display: 'flex', flexDirection: 'column', gap: '14px' }}>
              <div style={{ position: 'relative' }}>
                <label style={labelStyle}>Cliente *</label>
                <input type="text" placeholder="Digite para buscar..." value={buscaCliente}
                  onChange={e => { setBuscaCliente(e.target.value); setMostrarSugestoes(true); setFormCobranca(prev => ({ ...prev, cliente_id: '' })); }}
                  onFocus={() => setMostrarSugestoes(true)}
                  onBlur={() => setTimeout(() => setMostrarSugestoes(false), 200)}
                  style={inputStyle} />
                {mostrarSugestoes && buscaCliente && clientesFiltrados.length > 0 && (
                  <div style={{ position: 'absolute', top: '100%', left: 0, right: 0, background: 'white', border: '1px solid #ddd', borderRadius: '8px', boxShadow: '0 4px 12px rgba(0,0,0,0.15)', zIndex: 100, maxHeight: '200px', overflowY: 'auto' }}>
                    {clientesFiltrados.map((c, i) => (
                      <div key={i} onMouseDown={() => selecionarCliente(c, setFormCobranca)} style={{ padding: '10px 14px', cursor: 'pointer', fontSize: '14px' }} onMouseEnter={e => e.currentTarget.style.background = '#E1F5EE'} onMouseLeave={e => e.currentTarget.style.background = 'white'}>
                        👤 {c.nome_fantasia || c.nome}
                      </div>
                    ))}
                  </div>
                )}
                {formCobranca.cliente_id && <div style={{ fontSize: '11px', color: '#1D9E75', marginTop: '4px' }}>✅ Cliente selecionado</div>}
              </div>
              <div>
                <label style={labelStyle}>Descrição</label>
                <input type="text" placeholder="Descrição da cobrança" value={formCobranca.descricao} onChange={e => setFormCobranca(prev => ({ ...prev, descricao: e.target.value }))} style={inputStyle} />
              </div>
              <div>
                <label style={labelStyle}>Tipo</label>
                <select value={formCobranca.tipo} onChange={e => setFormCobranca(prev => ({ ...prev, tipo: e.target.value }))} style={{ ...inputStyle, background: 'white' }}>
                  <option value="unica">Cobrança Única</option>
                  <option value="parcelada">Parcelada</option>
                </select>
              </div>
              <div style={{ display: 'grid', gridTemplateColumns: formCobranca.tipo === 'parcelada' ? '1fr 1fr' : '1fr', gap: '12px' }}>
                <div>
                  <label style={labelStyle}>Valor Total (R$) *</label>
                  <input type="number" placeholder="0,00" value={formCobranca.valor} onChange={e => setFormCobranca(prev => ({ ...prev, valor: e.target.value }))} style={inputStyle} />
                </div>
                {formCobranca.tipo === 'parcelada' && (
                  <div>
                    <label style={labelStyle}>Parcelas</label>
                    <select value={formCobranca.parcelas} onChange={e => setFormCobranca(prev => ({ ...prev, parcelas: e.target.value }))} style={{ ...inputStyle, background: 'white' }}>
                      {[2,3,4,5,6,7,8,9,10,11,12].map(n => <option key={n} value={n}>{n}x de R$ {formCobranca.valor ? (formCobranca.valor / n).toFixed(2) : '0,00'}</option>)}
                    </select>
                  </div>
                )}
              </div>
              <div>
                <label style={labelStyle}>Forma de Pagamento</label>
                <select value={formCobranca.forma_pagamento} onChange={e => setFormCobranca(prev => ({ ...prev, forma_pagamento: e.target.value }))} style={{ ...inputStyle, background: 'white' }}>
                  {formasPagamento.map(f => <option key={f.value} value={f.value}>{f.label}</option>)}
                </select>
              </div>
              <div>
                <label style={labelStyle}>Vencimento *</label>
                <input type="date" value={formCobranca.vencimento} onChange={e => setFormCobranca(prev => ({ ...prev, vencimento: e.target.value }))} style={inputStyle} />
              </div>
            </div>
            <div style={{ padding: '16px 24px', borderTop: '1px solid #eee', display: 'flex', justifyContent: 'flex-end', gap: '12px', position: 'sticky', bottom: 0, background: 'white' }}>
              <button onClick={() => setModalCobranca(false)} style={{ background: '#f0f0f0', color: '#666', border: 'none', borderRadius: '8px', padding: '10px 20px', cursor: 'pointer', fontWeight: '600' }}>Cancelar</button>
              <button onClick={salvarCobranca} disabled={salvando} style={{ background: salvando ? '#ccc' : '#1D9E75', color: 'white', border: 'none', borderRadius: '8px', padding: '10px 24px', cursor: salvando ? 'not-allowed' : 'pointer', fontWeight: '600' }}>
                {salvando ? '⏳ Salvando...' : '✅ Criar Cobrança'}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default Financeiro;